export default __webpack_public_path__ + "static/media/92.22fc017f.gif";